import { Action } from 'redux';

import { isActionFactory } from '~src/bootstrap/redux/actions/isActionFactory';
import { IBroadcastableItemInfo } from '~src/spacesPlatform/models/resourceInfoParts';

import { BroadcastViewCreated, CreateBroadcastView, DeleteBroadcastView } from '../../bootstrap/redux/actions/AppActionTypes';
export interface CreateBroadcastViewAction extends Action {
    item: IBroadcastableItemInfo;
}

export function createBroadcastView(item: IBroadcastableItemInfo): CreateBroadcastViewAction {
    return {
        type: CreateBroadcastView,
        item,
    };
}

export function broadcastViewCreated(item: IBroadcastableItemInfo) {
    return {
        type: BroadcastViewCreated,
        item,
    };
}

export const isBroadcastViewCreatedAction = isActionFactory<CreateBroadcastViewAction>(BroadcastViewCreated);


export interface DeleteBroadcastViewAction extends Action {
    item: IBroadcastableItemInfo;
}

export function deleteBroadcastView(item: IBroadcastableItemInfo): DeleteBroadcastViewAction {
    return {
        type: DeleteBroadcastView,
        item,
    };
}